import useShopSuspense from "@babackapp/private-api-client/client/use-shop-suspense";
import { useParams } from "react-router-dom";

export function useCurrentShopSuspense() {
  const { shopId } = useParams<{ shopId: string }>();
  return useShopSuspense(shopId);
}
